//export const BASE_URL = "https://localhost:5001";
export const BASE_URL = "https://bikecafe-admin.foxnet-polska.pl"